import type { Journey, User } from "~/api/types";
import { BRDGE_PROJECT_ID } from "~/lib/config";

export const useJourneyStore = defineStore(`journey_${BRDGE_PROJECT_ID}`, {
  state: (): {
    journey: Journey;
    user: User;
  } => ({
    journey: null,
    user: null,
  }),
  actions: {
    setJourney(journey: Journey) {
      this.journey = journey;
    },
    setUser(user: User) {
      this.user = user;
    },
  },
  persist: {
    storage: persistedState.localStorage,
  },
});
